class FreeShippingBar extends HTMLElement {
  constructor() {
    super();
  }
  static async refresh() {
    fetch("/")
      .then((response) => response.text())
      .then((response) => {
        let newHtml = new DOMParser().parseFromString(response, "text/html");
        if (
          document.querySelector("#free-shipping-bar") &&
          newHtml.querySelector("#free-shipping-bar")
        ) {
          document.querySelector("#free-shipping-bar").innerHTML =
            newHtml.querySelector("#free-shipping-bar").innerHTML;
        }
      });
  }
  async refresh() {
    fetch("/")
      .then((response) => response.text())
      .then((response) => {
        let newHtml = new DOMParser().parseFromString(response, "text/html");
        if (
          document.querySelector("#free-shipping-bar") &&
          newHtml.querySelector("#free-shipping-bar")
        ) {
          document.querySelector("#free-shipping-bar").innerHTML =
            newHtml.querySelector("#free-shipping-bar").innerHTML;
        }
      });
  }
}

customElements.define("free-shipping-bar", FreeShippingBar);
